export default __webpack_public_path__ + "static/media/pub-sounds.5c70a487.mp3";